export default "__VITE_ASSET__eddc83b8__"